import { useMutation } from "@apollo/react-hooks";

import createMessageMutation from "../graphql/createMessage.graphql";

const useMutationCreateMessage = ({ onCompleted }: any) =>
  useMutation(createMessageMutation, { onCompleted });

export default useMutationCreateMessage;
